import { Separator } from "@radix-ui/react-separator";

interface MenuOptionsProps {
  menuOptions: MenuOption[];
}

interface MenuOption {
  id: string;
  label: string;
  icon: React.ReactNode;
  separator?: boolean;
  onClick: () => void;
}

export function MenuOptions({ menuOptions }: MenuOptionsProps) {
  return (
    <div>
      {menuOptions.map((option, index) => (
        <div key={option.id}>
          <div
            className="relative flex gap-3 select-none items-center rounded-sm pl-3 pr-1 py-2 outline-none cursor-pointer hover:bg-[rgba(249,250,251,1)] transition-colors"
            onClick={option.onClick}
          >
            {option.icon && (
              <span className="h-4 w-4 shrink-0">{option.icon}</span>
            )}
            <span className="text-sm text-i-normal font-medium">
              {option.label}
            </span>
          </div>

          {option.separator && index < menuOptions.length - 1 && (
            <Separator className="-mx-1 my-1 h-px bg-[rgba(234,236,240,1)]" />
          )}
        </div>
      ))}
    </div>
  );
}